(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gdb-popup-promo"]) return;
  try {
    
  (function () {
    var el = document.getElementById('gdb-popup');
    if (!el || el.dataset.gdbPronto) return;
    el.dataset.gdbPronto = '1';

    var CHAVE_FEITO = 'gdb_popup_feito';
    var CHAVE_FECHADO = 'gdb_popup_fechado';
    var forcar = /[?&]gdb_popup=1/.test(location.search);
    var design = el.dataset.design === 'true';
    var form = el.querySelector('form');
    var erro = el.querySelector('.gdb-popup__erro');
    var tel = form.elements.telefone;
    var aberto = false;

    function ler(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function gravar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function podeAbrir() {
      if (forcar) return true;
      if (el.dataset.ativo !== 'true') return false;
      if (el.dataset.template === 'cart') return false;
      if (el.dataset.onde === 'home' && el.dataset.template !== 'index') return false;
      if (ler(CHAVE_FEITO)) return false;
      var fechado = Number(ler(CHAVE_FECHADO) || 0);
      var dias = Number(el.dataset.dias || 7);
      return !fechado || Date.now() - fechado > dias * 864e5;
    }

    function abrir() {
      if (aberto) return;
      aberto = true;
      el.hidden = false;
      // dois frames: o navegador precisa pintar o estado inicial antes da transicao
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('gdb-popup--aberto'); });
      });
      evento('gdb_popup_view');
    }

    function fechar(lembrar) {
      if (!aberto) return;
      aberto = false;
      el.classList.remove('gdb-popup--aberto');
      setTimeout(function () { el.hidden = true; }, 550);
      if (lembrar && !forcar) gravar(CHAVE_FECHADO, String(Date.now()));
    }

    function evento(nome, extra) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: nome }, extra || {}));
      } catch (e) {}
    }

    function mascarar() {
      var d = tel.value.replace(/\D/g, '');
      if (d.length > 11 && d.indexOf('55') === 0) d = d.slice(2);
      d = d.slice(0, 11);
      var o = d;
      if (d.length > 2) o = '(' + d.slice(0, 2) + ') ' + d.slice(2);
      if (d.length > 7) o = '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
      tel.value = o;
    }

    function mostrarErro(msg, campo) {
      erro.textContent = msg;
      erro.hidden = false;
      if (campo) { campo.classList.add('gdb-popup--invalido'); campo.focus(); }
    }

    function utms() {
      var o = {};
      try {
        new URLSearchParams(location.search).forEach(function (v, k) {
          if (/^(utm_|fbclid|gclid)/.test(k)) o[k] = v.slice(0, 120);
        });
      } catch (e) {}
      return o;
    }

    function sucesso(cupom, whatsapp) {
      if (cupom) el.querySelector('[data-gdb-popup-cupom]').textContent = cupom;
      el.querySelector('[data-gdb-popup-wa]').hidden = !whatsapp;
      el.querySelector('[data-gdb-popup-passo="form"]').hidden = true;
      el.querySelector('[data-gdb-popup-passo="sucesso"]').hidden = false;
      if (!forcar) gravar(CHAVE_FEITO, '1');
      // deixa o cupom aplicado na sessao: o checkout ja abre com o desconto
      var codigo = cupom || el.dataset.cupom;
      if (codigo) fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).catch(function () {});
      evento('gdb_popup_lead', { cupom: codigo });
      try { if (window.fbq) window.fbq('track', 'Lead', { content_name: 'popup_promo' }); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', { method: 'popup_promo' }); } catch (e) {}
    }

    tel.addEventListener('input', mascarar);
    form.addEventListener('input', function (e) {
      e.target.classList.remove('gdb-popup--invalido');
      erro.hidden = true;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (el.classList.contains('gdb-popup--enviando')) return;
      var nome = form.elements.nome.value.trim();
      var digitos = tel.value.replace(/\D/g, '');
      if (nome.length < 2) return mostrarErro('Digite seu nome.', form.elements.nome);
      if (digitos.length !== 11 || digitos[2] !== '9') return mostrarErro('Digite o WhatsApp com DDD. Ex.: (37) 99999-9999', tel);

      var botao = form.querySelector('.gdb-popup__botao');
      el.classList.add('gdb-popup--enviando');
      botao.disabled = true;

      fetch(el.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: nome,
          telefone: digitos,
          site: form.elements.site.value,
          pagina: location.pathname,
          utm: utms()
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
        .then(function (res) {
          if (res.j && res.j.ok) return sucesso(res.j.cupom, res.j.whatsapp);
          if (res.j && res.j.erro === 'telefone') return mostrarErro('Número inválido. Confira o DDD e o número.', tel);
          if (res.j && res.j.erro === 'nome') return mostrarErro('Digite seu nome.', form.elements.nome);
          // falha nossa nao pode custar a venda: entrega o cupom do tema
          sucesso(el.dataset.cupom, false);
        })
        .catch(function () { sucesso(el.dataset.cupom, false); })
        .then(function () {
          el.classList.remove('gdb-popup--enviando');
          botao.disabled = false;
        });
    });

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-gdb-popup-fechar]')) return fechar(true);
      var copiar = e.target.closest('[data-gdb-popup-copiar]');
      if (!copiar) return;
      var codigo = el.querySelector('[data-gdb-popup-cupom]').textContent.trim();
      var ok = function () {
        copiar.textContent = 'Copiado!';
        setTimeout(function () { copiar.textContent = 'Copiar'; }, 1800);
      };
      // webview de Instagram/TikTok nao tem navigator.clipboard
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(ok, ok);
      } else {
        var t = document.createElement('textarea');
        t.value = codigo;
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (err) {}
        t.remove();
        ok();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aberto) fechar(true);
    });

    // editor do tema: abre ao selecionar a secao, fecha ao sair
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(el)) abrir();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target.contains(el)) fechar(false);
    });
    if (design) return;

    if (!podeAbrir()) return;
    if (forcar) return abrir();

    var atraso = Number(el.dataset.atraso || 8) * 1000;
    var alvo = Number(el.dataset.scroll || 30) / 100;
    var timer = setTimeout(disparar, atraso);

    function rolou() {
      var doc = document.documentElement;
      var total = doc.scrollHeight - window.innerHeight;
      if (total > 0 && window.scrollY / total >= alvo) disparar();
    }
    function disparar() {
      clearTimeout(timer);
      window.removeEventListener('scroll', rolou);
      // nao sobe em cima de gaveta/modal aberto (carrinho, busca, menu)
      if (document.querySelector('dialog[open]')) { timer = setTimeout(disparar, 4000); return; }
      abrir();
    }
    if (alvo > 0) window.addEventListener('scroll', rolou, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
